import { httpClient } from "@/services";
import { locationsToAddFromExtract } from '@/store/modules/trips/Helpers/locations';
import getAllLoadsFiles from '@/utils/dispatch/trips/getAllLoadsFiles';
export default {
	state: {
		tripDialog: null,
		tripDialogConnections: null,
		tripDialogDriverBrokers: null,
		tripDialogDriverNewBrokers: null,
		tripPPWFiles: null,
		tripPPWFilesTable: null,
		tripSelectedPPWFiles: null,
		tripSelectedPPWFilesTable: null,
		extractGPT: null,
		tripItemFiles: null,
		tripItemView: null,
	},
	mutations: {
		updatePPWFiles(state, payload) {
			const { data } = payload;
			const newArray = [];
			data.file.forEach(file => {
				newArray.push({
					type: file.type,
					url: file.image,
					name: file.image.split("/").pop(),
					id: file.load_image_id
				});
			});

			newArray.push({
				type: "Invoice",
				url: data.invoice.file,
				name: data.invoice.file.split("/").pop(),
				id: "Invoice"
			});

			state.tripPPWFiles = data;
			state.tripPPWFilesTable = newArray;
		},
		updateSelectedPPWFiles(state, payload) {
			const { data } = payload;
			const newArray = [];
			data.file.file.forEach(file => {
				newArray.push({
					type: file.type,
					url: file.file,
					name: file.name,
				});
			});

			newArray.push({
				type: "Invoice",
				url: data.file.invoice[0].file,
				name: data.file.invoice[0].file.split("/").pop(),
			});

			state.tripSelectedPPWFiles = data;
			state.tripSelectedPPWFilesTable = newArray;
		},
		updateCreatePPWFile(state, payload ) {
			const { ppw } = payload;
			const { create_at, file, name, load_id, ppw_created_by } = ppw;
			const { trip } = state.tripDialog;
			const { loads } = trip;
			const activeLoad = loads.find(item => item.load_id === load_id);
			activeLoad.ppw = 1;
			activeLoad.ppw_created_by = ppw_created_by;
			activeLoad.ppw_date = create_at;
			activeLoad.ppw_file = file;
			activeLoad.ppw_name = name;
		},
		updateTripDialog(state, payload) {
			state.tripDialog = payload;
		},
		updateTripDialogConnections(state, payload) {
			state.tripDialogConnections = payload;
		},
		// Vuex mutation
		updateExtractGPT(state, payload) {
			// 1) Зберігаємо сирий extract як є
			state.extractGPT = payload;

			// 2) Гарантуємо наявність масиву загальних локацій
			if (!state.tripDialog) state.tripDialog = { location: [] };
			if (!Array.isArray(state.tripDialog.location)) state.tripDialog.location = [];

			// 3) Рахуємо, що треба додати, порівнюючи з існуючим state.tripDialog.location
			const toAdd = locationsToAddFromExtract(payload, state.tripDialog.location);

			// 4) Додаємо лише нові
			if (toAdd.length) {
				state.tripDialog.location.push(...toAdd);
			}

			payload.location = [ ...state.tripDialog.location ];
		},

		updateTripDialogBrokers(state, payload) {
			const { filterBrockers, broker } = payload || {};

			if (Array.isArray(filterBrockers)) {
				state.tripDialogDriverBrokers = [ ...filterBrockers ];
			}

			if (broker) {
				const { broker_id, value, mc } = broker;

				state.tripDialogDriverNewBrokers = broker;

				const currentList = Array.isArray(state.tripDialogDriverBrokers)
					? [ ...state.tripDialogDriverBrokers ]
					: [];

				const exists = currentList.some(item => Number(item.id) === Number(broker_id));

				if (!exists) {
					currentList.push({
						id: broker_id,
						value,
						mc: mc || null
					});
				}

				state.tripDialogDriverBrokers = currentList;
			}
		},
		updateTripDialogBilling(state, payload) {
			const loads = state.tripDialog.trip.loads;
			const { load_id } = payload;
			const load = loads.find(obj => obj.load_id === load_id);

			load.billing = { ...payload };
		},
		updateTripItemFiles(state, files) {
			state.tripItemFiles = Array.isArray(files) ? files : [];
		},
		updateTripItemView(state, payload) {
			state.tripItemView = payload;
		}
	},
	actions: {
		async getIdLoad({ dispatch }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/trips/load`, value);
				dispatch("actionPreloader", false);
				const { load_id } = data;
				return load_id;
			} catch (e) {
				console.error(e);
			}
		},
		async getTripItemFiles({ dispatch, commit }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/trips/${ value }`);

				const tripId = (data && data.trip && data.trip.trip_id != null)
					? data.trip.trip_id
					: null;

				const loads = (data && data.trip && Array.isArray(data.trip.loads))
					? data.trip.loads
					: [];

				const files = getAllLoadsFiles(loads, tripId);

				commit("updateTripItemFiles", files);
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getTripItemView({ dispatch, commit }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/trips/${ value }`);
				commit("updateTripItemView", data);
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async createPPWFile({ dispatch }, args) {
			dispatch("actionPreloader", true);
			const { id, value } = args;
			try {
				const { data } = await httpClient.post(`/loads/ppw/${ id }`, value);
				dispatch("actionPreloader", false);
				// commit('updateCreatePPWFile', data);
				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async sendPPWFile({ dispatch }, args) {
			dispatch("actionPreloader", true);
			const { id, value } = args;
			try {
				const { data } = await httpClient.post(`loads/sendPPW/${ id }`, { data: value });
				dispatch("actionPreloader", false);
				dispatch("setAlert", {
					type: "success",
					message: "Sended Successfully",
				});
				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async getSelectedPPWFiles({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/loads/ppwSelected/${ id }`);
				commit('updateSelectedPPWFiles', { data, flag: 'Selected' });
				dispatch("actionPreloader", false);
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async getPPWFiles({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/loads/ppw/${ id }`);
				commit('updatePPWFiles', { data });
				dispatch("actionPreloader", false);
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async removeBillingInvoiced({ dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.delete(`/billing/${ id }`);
				dispatch("actionPreloader", false);
				if (data) return data.status;
				dispatch("setAlert", { type: "error", message: 'Whoops, something went wrong! 🙁' });
				return data;
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async getTripDialog({ commit, dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`/trips/${ id }`);
				if (data && !data.status) {
					commit('updateTripDialog', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async getTripDialogConnections({ dispatch, commit }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/trips/connection', values);
				commit('updateTripDialogConnections', data);
				dispatch("actionPreloader", false);
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async getExtractGPT({ commit }, values) {
			try {
				const { data } = await httpClient.post('/trips/extract', values);
				commit('updateExtractGPT', data);
			} catch (e) {
				console.error(e);
			}
		},
		async generateBilling({ dispatch, commit }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/billing', values);
				commit('updateTripDialogBilling', data);
				dispatch("actionPreloader", false);
				if (data) return data;
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async getTripDialogBrokers({ dispatch, commit }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/filterBrockers', values);
				commit('updateTripDialogBrokers', data);
				dispatch("actionPreloader", false);
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async addNewBrokersTripDialog({ dispatch, commit }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/broker/new', values);

				commit('updateTripDialogBrokers', data);

				// після створення брокера оновлюємо весь список брокерів
				await dispatch('getTripDialogBrokers');

				dispatch("actionPreloader", false);
				return data;
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async saveTrip({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { trip_id } = values;
				const { data } = await httpClient.post(`/trips/update/${ trip_id }`, values);
				// const { data } = await httpClient.post(`/trips/update/${ trip_id }`, values);
				// commit('updateTripDialogBrokers', data);
				dispatch("actionPreloader", false);
				if (data) return data.trip_id;
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
		async getLocationTripDialog({ dispatch }, values) {
			try {
				const { data } = await httpClient.post('/location', values);
				if (data) return data.location;
				dispatch("setAlert", { type: "error", message: 'Whoops, something went wrong! 🙁' });
			} catch (e) {
				console.error(e);
			}
		},
		async getMileage({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/trips/milesTrip', values);
				dispatch("actionPreloader", false);
				if (data) return data.mileage;
				dispatch("setAlert", { type: "error", message: 'Whoops, something went wrong! 🙁' });
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		tripDialog: s => s.tripDialog,
		tripDialogConnections: s => s.tripDialogConnections,
		tripDialogDriverBrokers: s => s.tripDialogDriverBrokers,
		tripDialogDriverNewBrokers: s => s.tripDialogDriverNewBrokers,
		tripPPWFiles: s => s.tripPPWFiles,
		tripPPWFilesTable: s => s.tripPPWFilesTable,
		tripSelectedPPWFiles: s => s.tripSelectedPPWFiles,
		tripSelectedPPWFilesTable: s => s.tripSelectedPPWFilesTable,
		extractGPT: s => s.extractGPT,
		tripItemFiles: s => s.tripItemFiles,
		tripItemView: s => s.tripItemView,
	}
};

